__turbopack_context__.v({
  "carousel": "index-module-scss-module__jHZySW__carousel",
  "carousel-cell": "index-module-scss-module__jHZySW__carousel-cell",
  "counter": "index-module-scss-module__jHZySW__counter",
  "full-screen-carousel": "index-module-scss-module__jHZySW__full-screen-carousel",
  "full-screen-figure": "index-module-scss-module__jHZySW__full-screen-figure",
  "full-screen-img": "index-module-scss-module__jHZySW__full-screen-img",
  "full-screen-picture": "index-module-scss-module__jHZySW__full-screen-picture",
  "image": "index-module-scss-module__jHZySW__image",
});
